
export class SubjektasApi {
  id: number = 0;
  tipas: any;
  kodas: any;
  pavadinimas: any;
  telefonas: any;
  elPastas: any;
  faksas: any;
  asmRysiams: any;
  adresas: any;
  busena: any;

}
